<template>
  <div class="header">
    <el-row>
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <div class="left">
            <div class="logo"></div>
            企鹅互助后台管理系统
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <div class="right">
            <el-dropdown trigger="hover">
              <div class="avatar" ></div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>{{username}}</el-dropdown-item>
                <el-dropdown-item @click.native="dialogFormVisible = true">修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="handleLoginout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="time">
              <span style="margin-right:20px;font-size:14px">当前时间：{{ date }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 修改密码 -->
     <el-dialog :visible.sync="dialogFormVisible" width="40%">
      <div slot="title">修改密码</div>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="原密码" prop="oldpass"  :label-width="formLabelWidth" required>
          <el-input v-model="form.oldpass" type="password" placeholder="原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newpass"  :label-width="formLabelWidth" required>
          <el-input v-model="form.newpass" type="password" placeholder="新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repass"  :label-width="formLabelWidth" required>
          <el-input v-model="form.repass" type="password" placeholder="确认密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('form')">修 改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from 'api/api_user'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'HomeHeader',
  data () {
    let validatePass = (rule, value, callback) => {
      if (value !== this.form.newpass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    let validateNewPass = (rule, value, callback) => {
      if (value === this.form.oldpass) {
        callback(new Error('新旧密码一致!'))
      } else {
        callback()
      }
    }
    let validateOld = (rule, value, callback) => {
      if (value !== this.password) {
        callback(new Error('原密码输入错误!'))
      } else {
        callback()
      }
    }
    return {
      dialogFormVisible: false,
      form: {
        oldpass: '',
        newpass: '',
        repass: ''
      },
      rules: {
        oldpass: [
          {required: true, message: '请输入原始密码', trigger: 'blur'},
          {validator: validateOld, trigger: 'blur'}
        ],
        newpass: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          {validator: validateNewPass, trigger: 'blur'}
        ],
        repass: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'}
        ]
      },
      formLabelWidth: '120px',
      timer: null,
      time: new Date()
    }
  },
  computed: {
    ...mapState(['token', 'username', 'password', 'employer']),
    date () {
      let myDate = this.time
      let y = myDate.getFullYear()
      let m = myDate.getMonth() + 1
      let d = myDate.getDate()
      let h = myDate.getHours()
      let mins = myDate.getMinutes()
      let min = ''
      if (mins.toString().length <= 1) {
        min = '0' + mins
      } else if (mins.toString().length > 1) {
        min = mins
      }
      let s = myDate.getSeconds()
      let ss = ''
      if (s.toString().length <= 1) {
        ss = '0' + s
      } else if (s.toString().length > 1) {
        ss = s
      }
      return y + '年' + m + '月' + d + '日' + '  ' + h + ':' + min + ':' + ss
    }
  },
  methods: {
    // 退出登录
    handleLoginout () {
      let that = this
      API.logout('').then((res) => {
        if (res.code === 0) {
          localStorage.removeItem('mode')
          window.location.reload()
          that.$router.push('/')
        } else {
          this.$message.error('退出登录失败')
        }
      }, (error) => {
        console.log(error)
      })
    },
    // 修改密码
    handleSubmit (form) {
      let that = this
      this.$refs[form].validate((valid) => {
        if (valid) {
          let params = {newPassword: this.form.newpass, password: this.form.oldpass}
          API.updPwd(params).then((res) => {
            if (res.code === 0) {
              that.$message({showClose: true, message: '修改成功', duration: 2000})
              that.dialogFormVisible = false
              that.changePassword(that.form.newpass)
            } else {
              that.$message.error('修改失败 ' + res.msg)
            }
          }, (error) => {
            console.log(error)
          })
        } else {
          return false
        }
      })
    },
    ...mapActions(['changePassword'])
  },
  mounted () {
    let that = this
    this.timer = setInterval(function () {
      that.time = new Date()
    }, 1000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/variable.styl'
.header >>> .el-form-item__error
  top: 10px
  left: 310px
.header
  background-color $homeHeaderColor
  height 60px
  line-height 60px
  .logo
    float left
    width 36px
    height 36px
    margin 12px 12px 0 0
    background url('../img/logo.png')
    background-size contain
  .left
    // color #FF9D00
    color #fff
    font-weight bold
    padding-left 8px
    font-size 22px
    .span
      font-size 14px
      margin-left 15px
    .logo-img
      width 6%
      vertical-align middle
      margin-right 10px
  .right
    text-align right
    padding-right 2%
    color #fff
    cursor pointer
    .time
      float right
      display inline-block
      height 60px
      line-height 60px
    .el-dropdown
      float right
      color #fff
      .avatar
        margin-top 10px
        width 40px
        height 40px
        border-radius 20px
        overflow hidden
        background url('../img/avatar.jpg')
        background-size contain
</style>



// WEBPACK FOOTER //
// src/pages/home/components/HomeHeader.vue